<app-header></app-header>
<!-- Content -->
<div id="content">
  <section class="container availability  seo">
    <div class="row">
      <div class="col mb-2">
        <div class="col-md-12 page-header">
          <ul class="breadcrumb justify-content-start mb-0">
            <li><a href="">Home</a></li>
            <li class="active">{{searchData.cruiseline}}</li>
          </ul>
        </div>
        <div class="search-criteria">

          <!-- More info section -->
          <div class="top" *ngIf="MoreInfoShort != ''">
            <h1>{{searchData.cruiseline}} Packages</h1>

            <p id="readMoreWraper" *ngIf="!showMore"><span [innerHtml]="MoreInfoShort">......</span>
              <a (click)="readMore()">Read More</a>
            </p>
            <div @readAnim *ngIf="showMore">
              <!-- <div class="card card-body lesspadding"> -->
                <span [innerHtml]="MoreInfo"></span>
                <a (click)="readMore()">Read Less</a>
              <!-- </div> -->
            </div>
          </div>
          <!-- More info section -->

          <div class="bottom">
            <ul class="left">
              <li>
                <h3>Search Destinations/River</h3>
                <span *ngIf="searchData.destination==''"><strong>Any</strong></span>
                <span *ngIf="searchData.destination!=''"><strong>{{searchData.destination}}</strong></span>
              </li>
              <li class="border"></li>
              <li>
                <h3>Starting On</h3>
                <span *ngIf="searchData.period==''"><strong>Any</strong></span>
                <span *ngIf="searchData.period!=''"><strong>{{searchData.period}}</strong></span>
              </li>
              <li class="border"></li>
              <!-- <li>
                <h3>Cabins & Category</h3>
                <span><strong>{{activeRoom.adults}}</strong> Adults | <strong>{{activeRoom.childs}}</strong>
                  Children</span>
              </li> -->
            </ul>
            <ul class="right">
              <li class="position-relative">
                <a class="open-hide" (click)="toggleShare()" id="open-hide">
                  <i class="fas fa-share-alt"></i>
                  <i class="fas fa-times close_btn"></i>
                </a>
                <ul class="share-group menu" id="menu">
                  <li>
                    <p>
                      <span class="number">{{selectedCruises.length}}</span>
                      <span>Item<br> Selected</span>
                    </p>
                  </li>
                  <li>
                    <a class="whatsappheight " style="margin-top: 30px;" [href]="whatsappmsg" target="_blank">
                      <img src="https://lccintl.ezeeibe.com/cruisextranet/whatsapp.png">
                    </a>
                  </li>
                  <li>
                    <a class="modal-trigger" style="margin-top: 30px;" data-toggle="modal" data-target="#login-signup"
                      href="#">
                      <span class="ak-email"></span>
                    </a>
                  </li>
                </ul>
                <!-- Email this Search Popup Start-->
                <div id="login-signup" class="modal fade emailthis-search" role="dialog" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content p-sm-3">
                      <div class="modal-body">
                        <button type="button" id="shareSearch" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span></button>
                        <div class="justify-content-start row">
                          <h3>Email this Search</h3>
                        </div>
                        <div class="">
                          <form id="loginForm" method="post" autocomplete="off">
                            <div class="form-group">
                              <input type="email" class="form-control" id="loginMobile" [(ngModel)]="loginMobile"
                                name="loginMobile" required placeholder="Email ID">
                            </div>
                            <button class="btn btn-primary btn-block search_btn" type="submit"
                              (click)="submitlead()">Send</button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Email this Search Popup End-->
              </li>
              <li> <a data-toggle="modal" data-target="#flight-2" class="btns" id="modifysearch"><span
                    class="text">modify search</span></a></li>
            </ul>
          </div>
          <!--Modify Search Popup Start-->
          <app-modifySearch></app-modifySearch>
          <!--Modify Search Popup End-->
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Filter Start-->
      <aside class="col-lg-3 filter-row">
        <div class="resetallbtn" (click)="resetAll()">Reset All</div>
        <div class="bg-light shadow-md rounded p-3 filter">
          <div class="accordion accordion-alternate style-2" id="toggleAlternateS">
            <div class="card">
              <div class="card-header" id="stopss">
                <h5 class="mb-0"> <a href="#" data-toggle="collapse" data-target="#togglestopsSS" aria-expanded="true"
                    aria-controls="togglestopsSS">Date</a> </h5>
              </div>
              <div id="togglestopsSS" class="collapse show" aria-labelledby="stopss">
                <div class="card-body date">
                  <div class="custom-control custom-checkbox" *ngFor="let m of filterMonths; let i = index">
                    <input type="checkbox" [checked]="selectedMonths.indexOf(m.sailM)!=-1"
                      (click)="updateMonthFilter($event,m.sailM)" id="nonstop{{i}}" name="stop" class="custom-control-input">
                    <label class="custom-control-label" for="nonstop{{i}}">{{m.sailMDesc}}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="price">
                <h5 class="mb-0"> <a href="#" class="collapse" class="collapsed" data-toggle="collapse"
                    data-target="#togglePrice" aria-expanded="false" aria-controls="togglePrice">Price</a> </h5>
              </div>
              <div id="togglePrice" class="" aria-labelledby="price">
                <div class="card-body">
                  <p>
                    <input id="amount" type="text" readonly class="form-control border-0 bg-transparent p-0">
                  </p>
                  <div id="slider-range"></div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="priceSS">
                <h5 class="mb-0"> <a href="#" class="collapse" data-toggle="collapse" data-target="#togglePriceSS"
                    aria-expanded="true" aria-controls="togglePriceSS">Cruise Length</a> </h5>
              </div>
              <div id="togglePriceSS" class="collapse show" aria-labelledby="priceSS">
                <div class="card-body">
                  <div class="custom-control custom-checkbox clearfix" *ngFor="let n of filterNights;let i = index">
                    <input type="checkbox" [checked]="selectedNights.indexOf(n)!=-1" id="earlyMorning{{i}}"
                      name="departureTime" (click)="updateNightsFilter($event, n)" class="custom-control-input">
                    <label class="custom-control-label" for="earlyMorning{{i}}">{{n}}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="airlinesSS">
                <h5 class="mb-0"> <a href="#" class="collapse" data-toggle="collapse" data-target="#toggleAirlinesSS"
                    aria-expanded="true" aria-controls="toggleAirlinesSS">Destination / River</a> </h5>
              </div>
              <div id="toggleAirlinesSS" class="collapse show" aria-labelledby="airlinesSS">
                <div class="card-body">
                  <div class="custom-control custom-checkbox" *ngFor="let d of filterDestinations;let i = index">
                    <input type="checkbox" [checked]="selectedDestinations.indexOf(d.port)!=-1"
                      (click)="updateDestinationFilter($event, d.port)" id="dest{{i}}" name="airlines"
                      class="custom-control-input">
                    <label class="custom-control-label" for="dest{{i}}">{{d.port}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>
      <!-- Filter End-->

      <!-- Availability Start-->
      <div class="col-lg-9 col-md-12">
        <div class="rounded availability">
          <div class="sort_by_row">
            <div class="left">
              <div class="box"><span class="d-none d-sm-block">Sort By</span></div>
            </div>
            <div class="right">
              <div class="box">Departure date</div>
              <div class="box" (click)="sorting('cruiseLine')">Cruiseline</div>
              <div class="box" (click)="sorting('cruiseLength')">Cruise Length</div>
              <div class="box" (click)="sorting('price')">Price</div>
              <div class="show-hide"><span class="ak-show"></span>
                <!--<span class="ak-hide"></span>-->
              </div>
            </div>
          </div>
          <div class="flight-list" *ngFor="let cruise of filteredCruises; let k = index;">
            <div class="flight-item">
              <div class="checkbox-wrapper">
                <div class="checkbox">
                  <input type="checkbox" id="box{{k}}" (click)="selectCruise($event, cruise)">
                </div>
              </div>
              <div class="row align-items-center flex-row px-3">
                <div class=" col-12 brd-btm padg0">
                  <div class="row">
                    <div class="col-10 pt-1 pb-1">
                      <h2>{{cruise.Nights}} | {{cruise.FriendlyCruiseName}}</h2>
                    </div>

                    <div class="col-2 degree" *ngIf="cruise.logo != ''">
                      <img src="{{cruise.logo}}" width="90" height="40" alt="{{cruise.FriendlyCruiseName}}" />
                    </div>
                  </div>
                </div>
                <div class="col-12 padg0 pt-3">
                  <div class="row justify-content-between ">
                    <div class=" col-md-9">
                      <div class="row">
                        <div class=" col-lg-4 col-md-4 col-sm-4">
                          <a href="" *ngIf="cruise.thumbnail" (click)="setSelectedCruise(cruise)"
                            (click)="imageinfomation(cruise)" data-toggle="modal" data-target="#flight-3">
                            <img [src]="cruise.thumbnail" alt="" class="img-fluid" />
                          </a>
                          <a href="" *ngIf="!cruise.thumbnail" (click)="setSelectedCruise(cruise)"
                            (click)="imageinfomation(cruise)" data-toggle="modal" data-target="#flight-3">
                            <img src="../../assets/images/cruise.jpg" alt="" class="img-fluid" />
                          </a>
                          <div class="bottom-btns">
                            <a class="whatsapp" [href]="whatsAppUrl" target="_blank"><span class="ak-whatsapp"></span>
                              Whatsapp
                            </a>
                            <a class="send modal-trigger" (click)="setCruiseNameForLead(cruise)" data-toggle="modal"
                              data-target="#login-signup1">
                              <span class="ak-email"></span><span>Send Query</span> </a>
                          </div>
                        </div>
                        <div class="col-lg-8 col-md-8 col-sm-8">
                          <p class="cruise-features d-flex align-items-center text-4">
                            <span><i class="fas fa-ship icon"></i> <small>{{cruise.CruiseLine}}</small></span>
                          </p>
                          <p class="cruise-features d-flex align-items-center text-4">
                            <span><i class="fas fa-moon icon"></i> <small>{{cruise.Nights}}</small></span>
                          </p>
                          <p class="cruise-features d-flex align-items-center text-4">
                            <span><i class="fas fa-map-marker-alt icon"></i>
                              <small>{{cruise.EmbarkFrom}}</small><small>➝</small>
                              <small>{{cruise.EmbarkTo}}</small></span>
                          </p>
                          <p class="cruise-features d-flex align-items-center text-4">
                            <span><i class="fas fa-anchor icon"></i>
                              <small>{{cruise.Sailing}}</small></span>
                          </p>
                          <p class="cruise-features">Ports of Call may vary by departure date and subject to weather and
                            other conditions.</p>
                          <!-- <p class="cruise-features"><a href="">+ View More</a> </p> -->
                          <div class="offer">
                            <div class="block">Offer</div>
                            <p>Save Big Today with ZERO Convenience Fee</p>
                          </div>
                          <div class="offer">
                            <div class="block"> View Detailed</div>
                            <span class="sbmybooking text-2"> <span style="cursor: pointer;" href="javascript:void(0)"
                                data-target="#flight-3" data-toggle="modal" (click)="imageinfomation(cruise)"  (click)="setSelectedCruise(cruise)"
                                title="Detailed information about the Cruise">Click Here to View Detailed
                                  Itinerary</span></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class=" col-md-3 right-side top_board">
                      <div class="fare">
                        <p>Starting Price</p>
                        <h3>{{cruise.CurrencyCode}} {{cruise.StartPrice | number}}</h3>
                        <!-- <h6>Net Pay: {{cruise.CurrencyCode}} {{cruise.StartPrice | number}}</h6> -->
                        <h5 *ngIf="loginType=='B2B'">You Earn: {{cruise.CurrencyCode}} {{cruise.comm | number}}</h5>

                      </div>
                      <div class="lowest-rates-row">
                        <h5>Lowest Rates</h5>
                        <ul>
                          <li>Inside<span class="right">₹ {{cruise.lowinterior | number}}</span></li>
                          <li>Oceanview<span class="right">₹ {{cruise.lowoceanview | number}}</span></li>
                          <li>Balcony<span class="right">₹ {{cruise.lowbalcony | number}}</span></li>
                          <li>Suite<span class="right">₹ {{cruise.lowsuite | number}}</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="cruise.cabinPrice.length!=0" class="more_rooms_row">
                <div class="scroll">
                  <div class="head-row">
                    <div class="left">
                      <div class="box">Date </div>
                      <div class="box">Inside</div>
                      <div class="box">Oceanview</div>
                      <div class="box">Balcony</div>
                      <div class="box">Suite</div>
                    </div>
                  </div>
                  <div class="cont-row" *ngIf="cruise.cabinPrice.length>=1">
                    <div class="left">
                      <div class="box">{{cruise.cabinPrice[0].SailingDate}}</div>
                      <div class="box">₹ {{cruise.cabinPrice[0].interior | number}} <i class="fas fa-info-circle"></i>
                      </div>
                      <div class="box">₹ {{cruise.cabinPrice[0].oceanview | number}} <i class="fas fa-info-circle"></i>
                      </div>
                      <div class="box">₹ {{cruise.cabinPrice[0].balcony | number}} <i class="fas fa-info-circle"></i>
                      </div>
                      <div class="box">₹ {{cruise.cabinPrice[0].suite | number}} <i class="fas fa-info-circle"></i>
                      </div>
                      <div class="box-right">
                        <ul>
                          <li data-toggle="tooltip" title="Special-promotions"><i class="fas fa-bullhorn"
                              *ngIf="cruise.cabinPrice[0].offers.indexOf('Special Promotions')>-1"></i></li>
                          <li data-toggle="tooltip" title="Free internet"
                            *ngIf="cruise.cabinPrice[0].offers.indexOf('Free Internet')>-1"><i class="fas fa-wifi"></i>
                          </li>
                          <li data-toggle="tooltip" title="Non Refundable Deposit"
                            *ngIf="cruise.cabinPrice[0].offers.indexOf('Non refundable  Deposit')>-1"><span
                              class="ndr-icon">NDR</span></li>
                          <li data-toggle="tooltip" title="Buy One Get One Offer"
                            *ngIf="cruise.cabinPrice[0].offers.indexOf('BOGO Offer')>-1"><span class="ak-bogo"></span>
                          </li>
                          <li data-toggle="tooltip" title="Shore Excursion Credit"
                            *ngIf="cruise.cabinPrice[0].offers.indexOf('Shore Excursion Credit')>-1"><span
                              class="ak-shore-excursion-credit"></span></li>
                          <li data-toggle="tooltip" title="Free Gratuties"
                            *ngIf="cruise.cabinPrice[0].offers.indexOf('Free Gratuities')>-1"><span
                              class="ak-Free-gratities"></span></li>
                          <li data-toggle="tooltip" title="Kids Free"
                            *ngIf="cruise.cabinPrice[0].offers.indexOf('Kids Free')>-1"><span
                              class="ak-kids-free"></span></li>
                        </ul>
                      </div>
                    </div>
                    <div class="right">
                      <div class="box" (click)="bookNow(cruise.cabinPrice[0].SailingDate, cruise)">
                        <a href="javascript:void(0)" class="booknow">Book now</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Availability End-->

      <!-- Responsive Filter Popup Button Start-->
      <div class="filter-mobile-footer">
        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#myModalLeft">
          <span class="ak-filter icon"></span> <span>Filter</span> </button>
      </div>
      <!-- Responsive Filter Popup Button End-->

      <!-- Responsive Filter Left slide Start-->
      <div id="myModalLeft" class="modal fade modal-left" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Filter</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span
                  aria-hidden="true">&times;</span> </button>
            </div>
            <div class="modal-body">
              <aside class="col-lg-3">
                <div class="filter">
                  <div class="accordion accordion-alternate style-2" id="toggleAlternate">
                    <div class="card">
                      <div class="card-header" id="stops">
                        <h5 class="mb-0"> <a href="#" data-toggle="collapse" data-target="#togglestops"
                            aria-expanded="true" aria-controls="togglestops">Date</a> </h5>
                      </div>
                      <div id="togglestops" class="collapse show" aria-labelledby="stops">
                        <div class="card-body date">
                          <div class="custom-control custom-checkbox" *ngFor="let m of filterMonths; let i = index">
                            <input type="checkbox" [checked]="selectedMonths.indexOf(m)!=-1"
                              (click)="updateMonthFilter($event,m)" id="nonstop{{i}}" name="stop"
                              class="custom-control-input">
                            <label class="custom-control-label" for="nonstop{{i}}">{{m}}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-header" id="departureTimes">
                        <h5 class="mb-0"> <a href="#" class="collapse" data-toggle="collapse"
                            data-target="#toggleDepartureTimes" aria-expanded="true"
                            aria-controls="toggleDepartureTimes">Price per person</a> </h5>
                      </div>
                      <div id="toggleDepartureTimes" class="collapse show" aria-labelledby="departureTimes">
                        <div class="card-body">
                          <!-- <div class="card-body"> -->
                          <p>
                            <input id="amount1" type="text" readonly class="form-control border-0 bg-transparent p-0">
                          </p>
                          <div id="slider-range1"></div>
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-header" id="pricea">
                        <h5 class="mb-0"> <a href="#" class="collapse" data-toggle="collapse" data-target="#togglePricea"
                            aria-expanded="true" aria-controls="togglePricea">Cruise Length</a> </h5>
                      </div>
                      <div id="togglePricea" class="collapse show" aria-labelledby="pricea">
                        <div class="card-body">
                          <div class="custom-control custom-checkbox clearfix"
                            *ngFor="let n of filterNights;let i = index">
                            <input type="checkbox" [checked]="selectedNights.indexOf(n)!=-1" id="earlyMorning{{i}}"
                              name="departureTime" (click)="updateNightsFilter($event, n)" class="custom-control-input">
                            <label class="custom-control-label" for="earlyMorning{{i}}">{{n}}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-header" id="airlinesas">
                        <h5 class="mb-0"> <a href="#" class="collapse" data-toggle="collapse"
                            data-target="#toggleAirlinesas" aria-expanded="true"
                            aria-controls="toggleAirlinesas">Destination / River</a> </h5>
                      </div>
                      <div id="toggleAirlinesas" class="collapse show" aria-labelledby="airlinesas">
                        <div class="card-body">
                          <div class="custom-control custom-checkbox"
                            *ngFor="let d of filterDestinations;let i = index">
                            <input type="checkbox" [checked]="selectedDestinations.indexOf(d)!=-1"
                              (click)="updateDestinationFilter($event, d)" id="dest{{i}}" name="airlines"
                              class="custom-control-input">
                            <label class="custom-control-label" for="dest{{i}}">{{d}}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
            <div class="res-filter-footer">
              <div class="reset-btn" (click)="resetAll()">Reset</div>
              <div class="appaly-btn">Apply</div>
            </div>
          </div>
        </div>
      </div>
      <!-- Responsive Filter Left slide End-->
    </div>

  </section>
  <section class=" seo">
    <div class="container">
      <div>
        <section class="display-footer">

          <!-- <h2>Flights To Dubai</h2>
          <ul>
            <li> <a>Mumbai Kuala Lumpur Flights </a><span>|</span> </li>
            <li> <a>Delhi Kuala Lumpur Flights </a><span>|</span> </li>
            <li> <a>Chennai Kuala Lumpur Flights</a> </li>
          </ul>

          <h2>Akbar Recommended International Holidays</h2>
          <ul>
            <li> <a>Dubai Tour Packages</a><span>|</span> </li>
            <li> <a>Dubai Tour Packages </a><span>|</span> </li>
            <li> <a>Dubai Tour Packages </a><span>|</span> </li>
            <li> <a>Dubai Tour Packages </a><span>|</span> </li>
            <li> <a>Singapore Tour Packages</a> </li>
          </ul>

          <h2>Akbar Recommended Indian Holidays</h2>
          <ul>
            <li> <a>Dubai Tour Packages</a><span>|</span> </li>
            <li> <a>Dubai Tour Packages </a><span>|</span> </li>
            <li> <a>Dubai Tour Packages </a><span>|</span> </li>
            <li> <a>Dubai Tour Packages </a><span>|</span> </li>
            <li> <a>Singapore Tour Packages</a> </li>
          </ul> -->
          <h1 *ngIf="faqArray.length > 1">FAQ - All About {{searchData.cruiseline}}</h1>
        </section>
      </div>
      <div>
        <div id="accordion">
          <!-- <div class="card" *ngFor="let faq of faqArray;let i = index">
            <div class="card-header" id="headingOne{{i}}" >
              <h5 class="mb-0">
                <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseOne{{i}}" aria-expanded="true"
                  aria-controls="collapseOne{{i}}">
                  <span class="ak-down icon"></span>{{faq.faqTitle}}
                </button>
              </h5>
            </div>

            <div id="collapseOne{{i}}" class="collapse" aria-labelledby="headingOne{{i}}" data-parent="#accordion">
              <div class="card-body">
                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
                moon
                officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                Brunch 3 wolf
                moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.
                Nihil anim
                keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan
                excepteur
                butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you
                probably
                haven't heard of them accusamus labore sustainable VHS.
                 {{faq.faq}}
              </div>
            </div>
          </div> -->
          <div class="card" *ngFor="let faq of faqArray;let i = index">
            <div class="card-header" id="headingTwo{{i}}" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
              <h2 class="mb-0" itemprop="name">
                <button class="btn btn-link collapsed" (click)="showdiv(i,$event)" data-toggle="collapse"
                  data-target="#collapseTwo{{i}}" aria-expanded="false" aria-controls="collapseTwo{{i}}">
                  <span class="ak-down icon"></span> {{faq.faqTitle}}
                </button>
              </h2>
            </div>
            <div id="collapseTwo{{i}}" class="collapse" aria-labelledby="headingTwo{{i}}" data-parent="#accordion">
              <div class="card-body" itemprop="text" [innerHtml]="faq.faq">
                <!-- {{faq.faq}} -->
              </div>
            </div>
          </div>
          <!-- <div class="card">
            <div class="card-header" id="headingThree">
              <h5 class="mb-0">
                <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree"
                  aria-expanded="false" aria-controls="collapseThree">
                  <span class="ak-down icon"></span> How to reach dubai
                </button>
              </h5>
            </div>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
              <div class="card-body">
                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
                moon
                officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                Brunch 3 wolf
                moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.
                Nihil anim
                keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan
                excepteur
                butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you
                probably
                haven't heard of them accusamus labore sustainable VHS.
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div id="content" class="more-link">
      <div class="container">
        <div class="links">
          <div class="left1">

            <h2 class="ng-tns-c6-1">More Links</h2>
            <p class="ng-tns-c6-1"><a class="ng-tns-c6-1" href="https://blog.akbartravels.com/" rel="noopener"
                target="_blank">Blog</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">Branches</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">Bus Tickets</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">Travel
                Advisory</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Domestic
                Flights </a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">International
                Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Low Cost
                Airlines</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Cheap
                Flight
                Booking</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Cheap Air
                Tickets</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Flight
                Schedule</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">About
                Us</a><span class="slash"></span><a class="ng-tns-c6-1"
                href="https://www.blueribbonbags.com/MishandledBaggageReports" rel="noopener" target="_blank">Mishandled
                Baggage
                Report</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Partner
                With Us</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">FAQs</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">Legal</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">Careers</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">Retrieve
                Booking</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">News &amp;
                Events</a><span class="slash"></span><a class="ng-tns-c6-1"
                href="https://agents.akbartravelsonline.com/myaccount/login" rel="noopener" target="_blank">Partner
                Login</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">IRCTC
                Agent</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Download our
                Mobile App</a></p>
            <h2 class="ng-tns-c6-1">Visa</h2>
            <p class="ng-tns-c6-1"><a class="ng-tns-c6-1" href="javascript:;" rel="noopener" target="_blank">Dubai
                Visa</a><span class="slash"></span><a class="ng-tns-c6-1" href="javascript:;" rel="noopener"
                target="_blank">Singapore Visa</a><span class="slash"></span><a class="ng-tns-c6-1" href="javascript:;"
                rel="noopener" target="_blank">Malaysia
                Visa</a><span class="slash"></span><a class="ng-tns-c6-1" href="javascript:;" rel="noopener"
                target="_blank">Thailand Visa</a><span class="slash"></span><a class="ng-tns-c6-1" href="javascript:;"
                rel="noopener" target="_blank">Sri Lanka Visa</a><span class="slash"></span><a class="ng-tns-c6-1"
                href="javascript:;" rel="noopener" target="_blank">Schengen
                Visa</a><span class="slash"></span><a class="ng-tns-c6-1" href="javascript:;" rel="noopener"
                target="_blank">US Visa</a><span class="slash"></span><a class="ng-tns-c6-1" href="javascript:;"
                rel="noopener" target="_blank">UK Visa</a><span class="slash"></span><a class="ng-tns-c6-1"
                href="javascript:;" rel="noopener" target="_blank">China Visa</a><span class="slash"></span><a
                class="ng-tns-c6-1" href="javascript:;" rel="noopener" target="_blank">Australia Visa</a></p>
            <h2 class="ng-tns-c6-1">Domestic Tour Packages</h2>
            <p class="ng-tns-c6-1"><a class="ng-tns-c6-1" href="javascript:;" rel="noopener" target="_blank">Kashmir
                Holiday Packages</a><span class="slash"></span><a class="ng-tns-c6-1" href="javascript:;" rel="noopener"
                target="_blank">Leh Ladakh Packages</a><span class="slash"></span><a class="ng-tns-c6-1"
                href="javascript:;" rel="noopener" target="_blank">Goa
                Holidays</a><span class="slash"></span><a class="ng-tns-c6-1" href="javascript:;" rel="noopener"
                target="_blank">Andaman Holidays</a><span class="slash"></span><a class="ng-tns-c6-1"
                href="javascript:;" rel="noopener" target="_blank">Kerala Tour Packages</a><span class="slash"></span><a
                class="ng-tns-c6-1" href="javascript:;" rel="noopener" target="_blank">Himachal packages</a></p>
            <h2 class="ng-tns-c6-1">International tour packages</h2>
            <p class="ng-tns-c6-1"><a class="ng-tns-c6-1" href="javascript:;" rel="noopener" target="_blank">Dubai
                tour packages</a><span class="slash"></span><a class="ng-tns-c6-1" href="javascript:;" rel="noopener"
                target="_blank">Malaysia tour package</a><span class="slash"></span><a class="ng-tns-c6-1"
                href="javascript:;" rel="noopener" target="_blank">Singapore tour
                package</a><span class="slash"></span><a class="ng-tns-c6-1" href="javascript:;" rel="noopener"
                target="_blank">Thailand tour packages</a><span class="slash"></span><a class="ng-tns-c6-1"
                href="javascript:;" rel="noopener" target="_blank">Bali packages</a><span class="slash"></span><a
                class="ng-tns-c6-1" href="javascript:;" rel="noopener" target="_blank">Srilanka tour
                package</a><span class="slash"></span><a class="ng-tns-c6-1" href="javascript:;" rel="noopener"
                target="_blank">Europe tour packages</a><span class="slash"></span><a class="ng-tns-c6-1"
                href="javascript:;" rel="noopener" target="_blank">Mauritius packages</a><span class="slash"></span><a
                class="ng-tns-c6-1" href="javascript:;" rel="noopener" target="_blank">Maldives
                packages</a></p>

          </div>
          <div class="right1">

            <h2 class="ng-tns-c6-1">International Flight</h2>
            <p class="ng-tns-c6-1"><a class="ng-tns-c6-1" rel="noopener" target="_blank">Delhi Dubai Flights</a><span
                class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Delhi Bangkok
                Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Delhi
                Toronto
                Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Mumbai
                Dubai Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Delhi
                Singapore Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">Delhi
                London Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Delhi
                Kathmandu
                Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Mumbai
                London Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">Chennai
                Singapore Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">Mumbai
                Singapore Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">Delhi
                Newyork
                Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Kolkata
                Bangkok Flights</a></p>
            <h2 class="ng-tns-c6-1">Domestic Flight</h2>
            <p class="ng-tns-c6-1"><a class="ng-tns-c6-1" rel="noopener" target="_blank">Pune Bangalore
                Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Chennai
                Delhi Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">Bangalore
                Chennai
                Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Mumbai
                Delhi Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">Bangalore
                Hyderabad Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">Ahmedabad Goa Flights</a><span class="slash"></span><a class="ng-tns-c6-1"
                rel="noopener" target="_blank">Mumbai Kolkata
                Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Hyderabad
                Delhi Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener"
                target="_blank">Bangalore
                Goa Flights</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Mumbai
                Goa
                Flights</a></p>
            <h2 class="ng-tns-c6-1">International Airlines</h2>
            <p class="ng-tns-c6-1"><a class="ng-tns-c6-1" rel="noopener" target="_blank">Emirates Airlines</a><span
                class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Oman Air Airlines</a><span
                class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Air India Express
                Airlines</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Tiger
                Airways</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Kuwait
                Airways</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Air Arabia
                Airlines</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Etihad
                Airways</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Srilankan
                Airlines</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Air Asia
                India
                Airlines</a></p>
            <h2 class="ng-tns-c6-1">Domestic Airlines</h2>
            <p class="ng-tns-c6-1"><a class="ng-tns-c6-1" rel="noopener" target="_blank">Indigo Airlines</a><span
                class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Spicejet Airlines</a><span
                class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Air India
                Airlines</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Go Air
                Airlines</a><span class="slash"></span><a class="ng-tns-c6-1" rel="noopener" target="_blank">Air Costa
                Airlines</a></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<!-- Modal Dialog-->
<div id="flight-3" class="modal fade view_pop_row" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <!-- <i><img src="../assets/images/msc.jpg" width="89" height="34" alt=""/></i> -->
        <h5 class="modal-title">{{selectedCruise.Nights}} | {{selectedCruise.FriendlyCruiseName}} |
          {{selectedCruise.CruiseLine}}</h5>
        <button type="button" id="close-dialog" class="close" data-dismiss="modal" aria-label="Close"> <span
            aria-hidden="true">&times;</span> </button>
      </div>
      <div class="modal-body pt-0">
        <div class="flight-details">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item"> <a class="nav-link active" id="first-tab" data-toggle="tab" href="#first" role="tab"
                aria-controls="first" aria-selected="true">Itinerary</a>
            </li>
            <li class="nav-item"> <a class="nav-link" id="second-tab" data-toggle="tab" href="#second" role="tab"
                aria-controls="second" aria-selected="false">Sailing Dates</a>
            </li>
            <li class="nav-item"> <a class="nav-link" id="third-tab" data-toggle="tab" href="#third" role="tab"
                aria-controls="third" aria-selected="false">Cruise Info</a>
            </li>
            <li class="nav-item"> <a class="nav-link" id="fourth-tab" data-toggle="tab" href="#fourth" role="tab"
                aria-controls="fourth" aria-selected="false">Policies</a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="first" role="tabpanel" aria-labelledby="first-tab">
              <div class="flex-row pt-3">
                <div class="itinerary-cont">
                  <div class="left" *ngIf="selectedCruise.itineraryImage">
                    <img [src]="selectedCruise.itineraryImage" width="419" height="314" alt="" class="img-fluid" />
                  </div>
                  <div class="left" *ngIf="!selectedCruise.itineraryImage">
                    <img src="../../assets/images/img-.jpg" width="419" height="314" alt="" class="img-fluid" />
                  </div>
                  <div class="right">
                    <ul>
                      <li *ngFor="let itinerary of selectedCruise.itinerary;let i = index"><i
                          class="fas fa-ship icon"></i>
                        <b>Day {{i+1}}:</b> {{itinerary.BriefDesc}}<br>
                        <span><i class="far fa-clock icon"></i>Depart {{itinerary.Timings}}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <p>* Ports of Call may vary by departure date and subject to weather and other conditions.</p>
              </div>
            </div>
            <div class="tab-pane fade" id="second" role="tabpanel" aria-labelledby="second-tab">
              <div class="flex-row">
                <div class="more_rooms_row_popup">
                  <div class="scroll">
                    <div class="head-row">
                      <div class="left">
                        <div class="box">Date</div>
                        <div class="box">Inside</div>
                        <div class="box">Oceanview</div>
                        <div class="box">Balcony</div>
                        <div class="box">Suite</div>
                      </div>
                    </div>
                    <div class="cont-row" *ngFor="let cp of selectedCruise.cabinPrice">
                      <div class="left">
                        <div class="box">{{cp.SailingDate}}</div>
                        <div class="box">₹ {{cp.interior | number}} <i class="fas fa-info-circle"></i></div>
                        <div class="box">₹ {{cp.oceanview | number}} <i class="fas fa-info-circle"></i></div>
                        <div class="box">₹ {{cp.balcony | number}} <i class="fas fa-info-circle"></i></div>
                        <div class="box">₹ {{cp.suite | number}} <i class="fas fa-info-circle"></i> </div>
                        <div class="box-right">
                          <ul>
                            <li data-toggle="tooltip" title="Special-promotions"><i class="fas fa-bullhorn"
                                *ngIf="cp.offers.indexOf('Special Promotions')>-1"></i></li>
                            <li data-toggle="tooltip" title="Free internet"
                              *ngIf="cp.offers.indexOf('Free Internet')>-1"><i class="fas fa-wifi"></i>
                            </li>
                            <li data-toggle="tooltip" title="Non Refundable Deposit"
                              *ngIf="cp.offers.indexOf('Non refundable  Deposit')>-1"><span class="ndr-icon">NDR</span>
                            </li>
                            <li data-toggle="tooltip" title="Buy One Get One Offer"
                              *ngIf="cp.offers.indexOf('BOGO Offer')>-1"><span class="ak-bogo"></span>
                            </li>
                            <li data-toggle="tooltip" title="Shore Excursion Credit"
                              *ngIf="cp.offers.indexOf('Shore Excursion Credit')>-1"><span
                                class="ak-shore-excursion-credit"></span></li>
                            <li data-toggle="tooltip" title="Free Gratuties"
                              *ngIf="cp.offers.indexOf('Free Gratuities')>-1"><span class="ak-Free-gratities"></span>
                            </li>
                            <li data-toggle="tooltip" title="Kids Free" *ngIf="cp.offers.indexOf('Kids Free')>-1"><span
                                class="ak-kids-free"></span>
                            </li>
                            <!-- <li><span class="nonrefund">N</span></li>
                            <li><i class="fas fa-wine-glass-alt"></i></li>
                            <li><i class="fas fa-bullhorn"></i></li>
                            <li><i class="fas fa-wifi"></i></li> -->
                          </ul>
                        </div>
                      </div>
                      <div class="right">
                        <div (click)="bookNow(cp.SailingDate, selectedCruise)" class="box">
                          <a href="javascript:void(0)" class="booknow">Book now</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="third" role="tabpanel" aria-labelledby="third-tab">
              <div id="verticalTab">
                <div class="row no-gutters">
                  <div class="col-md-3 my-0 my-md-3">
                    <ul class="resp-tabs-list">
                      <li class="cruise-info-tab">Ship Info </li>
                      <li class="cruise-info-tab">Gallery</li>
                      <!-- <li class="cruise-info-tab">Deck Plans</li> -->
                      <li class="cruise-info-tab" id="staterooms-li">State rooms</li>
                      <!-- <li class="cruise-info-tab">Ship Facts</li> -->
                    </ul>
                  </div>
                  <div class="col-md-9">
                    <div class="resp-tabs-container bg-light shadow-md rounded h-100 p-2">
                      <div>
                        <div class="row">
                          <div class="col-12 col-md-5 mb-3 mb-md-0"> <img class="img-fluid rounded align-top"
                              [src]="selectedCruise.thumbnail" title="Standard Room" alt="Standard Room"> </div>
                          <div class="col-12 col-md-7 ship_info">
                            <h4 class="text-5">Ship Highlights</h4>
                            <!-- <ul class="simple-ul">
                                <li>Whether a family vacation, Luxury treat or romantic escape, MSC Poesia is a ship that offers a truly inspiring cruise experience.</li>
                                <li>Whether a family vacation, Luxury treat or romantic escape, MSC Poesia is a ship that offers a truly inspiring cruise experience.</li>
                                <li>Whether a family vacation, Luxury treat or romantic escape, MSC Poesia is a ship that offers a truly inspiring cruise experience.</li>
                              </ul> -->
                          </div>

                          <div class="col-12 col-md-12 ship_info" [innerHtml]="selectedCruise.ShipDesc">

                          </div>
                          <div class=" mt-1 col-md-12 ship_info">
                            <div class="row">
                              <div *ngFor="let info of selectedCruise.onboard"
                                class="col-md-12 col-lg-4 col-sm-12 pt-md-2 pt-sm-4 pt-4">
                                <div class="card">
                                  <div class="head">
                                    <div class="col-12 pt-1 pb-1">
                                      <h5>{{info.CategoryName}}</h5>
                                    </div>
                                    <!-- <div class="col-2 degree"> <img src="../assets/images/360-degree.png" width="32"
                                        height="32" alt="" /></div> -->
                                  </div>
                                  <div class="col-12" *ngIf="info.ImageURL"><img [src]="info.ImageURL"
                                      class="img-fluid rounded" alt="" /></div>
                                  <div class="col-12" *ngIf="!info.ImageURL"><img src="../assets/images/01.jpg"
                                      class="img-fluid rounded" alt="" /></div>
                                  <div class="col-12" [innerHtml]="info.Info">
                                  </div>
                                  <!-- <div class="col-12"><a href="javaScript:void(0)" class="view_details">View Details</a>
                                  </div> -->
                                </div>
                              </div>
                              <!-- <div class="col-md-12 col-lg-4 col-sm-12 pt-md-2 pt-sm-4 pt-4">
                                  <div class="card">
                                    <div class="head">
                                      <div class="col-10 pt-1 pb-1">
                                        <h2>Bars & Lounges</h2>
                                      </div>
                                      <div class="col-2 degree"> <img src="../assets/images/360-degree.png" width="32" height="32" alt=""/></div>
                                    </div>
                                    <div class="col-12"><img src="../assets/images/01.jpg" class="img-fluid rounded" alt=""/></div>
                                    <div class="col-12">
                                      <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec eros tellus, scelerisque nec, rhoncus eget, sollicitudin eu, vehicula venenatis, tempor vitae, est.</p>
                                    </div>
                                    <div class="col-12"><a href="" class="view_details">View Details</a></div>
                                  </div>
                                </div>
                                <div class="col-md-12 col-lg-4 col-sm-12 pt-md-2 pt-sm-4 pt-4">
                                  <div class="card">
                                    <div class="head">
                                      <div class="col-10 pt-1 pb-1">
                                        <h2>Dining</h2>
                                      </div>
                                      <div class="col-2 degree"> <img src="../assets/images/360-degree.png" width="32" height="32" alt=""/></div>
                                    </div>
                                    <div class="col-12"><img src="../assets/images/01.jpg" class="img-fluid rounded" alt=""/></div>
                                    <div class="col-12">
                                      <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec eros tellus, scelerisque nec, rhoncus eget, sollicitudin eu, vehicula venenatis, tempor vitae, est.</p>
                                    </div>
                                    <div class="col-12"><a href="" class="view_details">View Details</a></div>
                                  </div>
                                </div> -->
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <!-- Hotel Photo Slideshow  -->
                        <div class="owl-carousel owl-theme slideshow single-slider mb-3"
                          *ngIf="selectedCruise.gallery && selectedCruise.gallery[0]">
                          <div class="item" *ngFor="let img of selectedCruise.gallery"><a href="#">
                              <img class="imagesize" [src]="img.ImageURL" alt="" /></a>
                          </div>
                        </div>
                        <div class="owl-carousel owl-theme slideshow single-slider mb-3"
                          *ngIf="!selectedCruise.gallery || !selectedCruise.gallery[0]">
                          <div class="item"><a href="#"><img class="img-fluid" src="../assets/images/gallery-2.jpg"
                                alt="Standard Room photo" /></a></div>
                          <div class="item"><a href="#"><img class="img-fluid" src="../assets/images/gallery-3.jpg"
                                alt="Deluxe Room photo" /></a></div>
                          <div class="item"><a href="#"><img class="img-fluid" src="../assets/images/gallery-4.jpg"
                                alt="Premium Room photo" /></a></div>
                          <div class="item"><a href="#"><img class="img-fluid" src="../assets/images/gallery-5.jpg"
                                alt="Premium Room photo" /></a></div>
                        </div>
                        <!-- Hotel Photo Slideshow end -->
                      </div>
                      <!-- <div>
                          <div class="deck_plan_row">
                            <div class="image-box"><img src="../assets/images/cruise-pan.jpg" width="471" height="172" alt="" class="img-fluid"/></div>
                            <h3>Deck Description</h3>
                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec eros tellus, scelerisque nec, rhoncus eget, sollicitudin eu, vehicula venenatis,</p>
                          </div>
                          <div class="col-12 mt-3 deck_plan_bottom">
                            <div class="row">
                              <div class="col-lg-6 col-12 areas_tab">
                                <div class="heading">Public Areas</div>
                                <div class="accordion mt-2" id="accordionDefault">
                                  <div class="card">
                                    <div class="card-header" id="headingOne">
                                      <h5 class="mb-0"> <a href="#" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">Min Golf</a> </h5>
                                    </div>
                                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionDefault">
                                      <div class="card-body">
                                        <div class="row">
                                          <div class="col-md-5 col-lg-5"><img src="../assets/images/02.jpg" width="199" height="115" alt="" class="img-fluid"/></div>
                                          <div class="col-md-7 col-lg-7">
                                            <p>Iisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Mutat tacimates id sit.</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="card">
                                    <div class="card-header" id="headingTwo">
                                      <h5 class="mb-0"> <a href="#" class="collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">Jogging Track</a> </h5>
                                    </div>
                                    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionDefault">
                                      <div class="card-body">
                                        <div class="row">
                                          <div class="col-md-5 col-lg-5"><img src="../assets/images/02.jpg" width="199" height="115" alt="" class="img-fluid"/></div>
                                          <div class="col-md-7 col-lg-7">
                                            <p>Iisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Mutat tacimates id sit.</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="card">
                                    <div class="card-header" id="headingThree">
                                      <h5 class="mb-0"> <a href="#" class="collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">City Sports Park</a> </h5>
                                    </div>
                                    <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionDefault">
                                      <div class="card-body">
                                        <div class="row">
                                          <div class="col-md-5 col-lg-5"><img src="../assets/images/02.jpg" width="199" height="115" alt="" class="img-fluid"/></div>
                                          <div class="col-md-7 col-lg-7">
                                            <p>Iisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Mutat tacimates id sit.</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="heading">Public Areas</div>
                                <ul>
                                  <li><i class="fas fa-star"></i> 2 Twin Beds (convert to King) and 2  Upper Pullmans</li>
                                  <li><i class="fas fa-podcast"></i> 2 Twin Beds (convert to King) and 2  Upper Pullmans</li>
                                  <li><i class="fas fa-circle"></i> 2 Twin Beds (convert to King) and 2  Upper Pullmans</li>
                                  <li><i class="fas fa-compress"></i> Connecting Stateroom</li>
                                </ul>
                              </div>
                              <div class="col-lg-6 col-12 deck_plan_right">
                                <h6>Showing Deck Plan for: Sun</h6>
                                <div class="col-12">
                                  <div class="col-lg-6 d-inline-flex pt-2">
                                    <select class="custom-select" id="subject" required>
                                      <option value="">Select Your Subject</option>
                                      <option>Sun</option>
                                      <option>Booking</option>
                                      <option>Account</option>
                                      <option>Payment</option>
                                      <option>Other</option>
                                    </select>
                                  </div>
                                  <div class="col-lg-12 text-center pt-2"> <img src="../assets/images/cruise-pan-1.jpg" width="242" height="516" alt="" class="img-fluid"/> </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <div>
                          <div class="tabinner_tab">
                            <div class="col-md-12" id="staterooms">
                              <ul class="nav nav-tabs" id="myTab-3" role="tablist">
                                <li class="nav-item" *ngFor="let cb of allCabins;let i = index">
                                  <a class="nav-link" [ngClass]="i==0?'active':''" id="{{cb.category}}-tab"
                                    data-toggle="tab" href="#{{cb.category.replaceAll(' ','')}}" role="tab"
                                    aria-controls="suite" aria-selected="true"
                                    (click)="showclass(cb.category)">{{cb.category}}</a>
                                </li>
  
                              </ul>
                              <div class="tab-content my-3">
                                <div *ngFor="let cb of selectedCruise.cabins;let i = index" class="tab-pane fade"
                                  [ngClass]="cb.BaseCategory.replaceAll(' ','') == catename.replaceAll(' ','')?'show active':''"
                                  id="{{cb.BaseCategory.replaceAll(' ','')}}" role="tabpanel"
                                  aria-labelledby="{{cb.BaseCategory.replaceAll(' ','')}}-tab">
                                  <div class="row">
                                    <div class="col-md-12 col-lg-12 text-4">{{cb.CategoryName}}
                                    </div>
                                    <div class="row">
                                      <div class="col-md-5 col-lg-5"><img [src]="cb.ImageURL" alt="" class="img-fluid" />
                                      </div>
                                      <div class="col-md-7 col-lg-7" [innerHtml]="cb.Info">
                                      </div>
                                    </div>
  
                                    <div class="clearfix"></div>
                                  </div>
  
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="ship_facts_row" *ngIf="selectedCruise.shipFacts">
                            <img [src]="selectedCruise.shipFacts" width="100%" />
                          </div> -->
                          <div>
                            <div class="ship_facts_row">
                              <img [src]="selectedCruise.shipFacts" width="100%" />
                            </div>
                          </div>
                        </div>
                      <!-- <div class="ship_facts_row" *ngIf="selectedCruise.shipFacts">
                        <img [src]="selectedCruise.shipFacts" width="100%" />
                      </div> -->
                      <div>
                        <div class="ship_facts_row">
                          <img [src]="selectedCruise.shipFacts" width="100%" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="fourth" role="tabpanel" aria-labelledby="fourth-tab">
              <div class="col-12">
                <div class="accordion accordion-alternate toggle colaps_style" id="accordionAlternate">
                  <div class="card">
                    <div class="card-header" id="headingOneAlternate">
                      <h5 class="mb-0"> <a href="#" data-toggle="collapse" data-target="#collapseOneAlternate"
                          aria-expanded="true" aria-controls="collapseOneAlternate">Cancellation Policy</a> </h5>
                    </div>
                    <div id="collapseOneAlternate" class="collapse show" aria-labelledby="headingOneAlternate"
                      data-parent="#accordionAlternate">
                      <div class="card-body" [innerHtml]="selectedCruise.policies.Cancellation">

                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header" id="headingTwoAlternate">
                      <h5 class="mb-0"> <a href="#" class="collapsed" data-toggle="collapse"
                          data-target="#collapseTwoAlternate" aria-expanded="false"
                          aria-controls="collapseTwoAlternate">Gratuities Information</a> </h5>
                    </div>
                    <div id="collapseTwoAlternate" class="collapse" aria-labelledby="headingTwoAlternate"
                      data-parent="#accordionAlternate">
                      <div class="card-body" [innerHtml]="selectedCruise.policies.Gratuities"> </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header" id="headingThreeAlternate">
                      <h5 class="mb-0"> <a href="#" class="collapsed" data-toggle="collapse"
                          data-target="#collapseThreeAlternate" aria-expanded="false"
                          aria-controls="collapseThreeAlternate">Pregnancy Policy</a> </h5>
                    </div>
                    <div id="collapseThreeAlternate" class="collapse" aria-labelledby="headingThreeAlternate"
                      data-parent="#accordionAlternate">
                      <div class="card-body" [innerHtml]="selectedCruise.policies.Pregnancy"> </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header" id="headingfourAlternate">
                      <h5 class="mb-0"> <a href="#" class="collapsed" data-toggle="collapse"
                          data-target="#collapsefourAlternate" aria-expanded="false"
                          aria-controls="collapseThreeAlternate">Minor Accompany</a> </h5>
                    </div>
                    <div id="collapsefourAlternate" class="collapse" aria-labelledby="headingfourAlternate"
                      data-parent="#accordionAlternate">
                      <div class="card-body" [innerHtml]="selectedCruise.policies.Minor"> </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header" id="headingfiveAlternate">
                      <h5 class="mb-0"> <a href="#" class="collapsed" data-toggle="collapse"
                          data-target="#collapsefiveAlternate" aria-expanded="false"
                          aria-controls="collapseThreeAlternate">Smoking</a> </h5>
                    </div>
                    <div id="collapsefiveAlternate" class="collapse" aria-labelledby="headingfiveAlternate"
                      data-parent="#accordionAlternate">
                      <div class="card-body" [innerHtml]="selectedCruise.policies.Smoking"> </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal Dialog end -->

<!----------login Signup modal-------------------------------->
<div id="login-signup1" class="modal fade send-query-popup" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content p-sm-3">
      <div class="modal-body">
        <button type="button" id="leadModal" class="close" data-dismiss="modal" aria-label="Close"> <span
            aria-hidden="true">&times;</span></button>
        <div class="headtop">
          <h3>Our expert will get in touch with you shortly</h3>
          <h4>{{selectedCruise.CruiseLine}}</h4>
        </div>
        <div class="">
          <form id="loginForm1" method="post" autocomplete="off">
            <div class="form-group">
              <input type="name" name="name" [(ngModel)]="lead.name" class="form-control" (keypress)="onlyAlphabets($event)" required placeholder="Name">
            </div>
            <div class="form-group">
              <input type="email" name="email" [(ngModel)]="lead.email" class="form-control" required
                placeholder="Email ID">
            </div>
            <div class="form-group">
              <input type="email" name="phone" [(ngModel)]="lead.phone" class="form-control" (keypress)="numberOnly($event)" required
                placeholder="Phone Number">
            </div>
            <div class="form-group">
              <input type="email" name="City" [(ngModel)]="lead.city" class="form-control" (keypress)="onlyAlphabets($event)" required
                placeholder="Your City">
            </div>
            <div class="checkbox pt-2 pb-2 mt-2">
              <input type="checkbox" id="ch" (click)="termc($event)">
              <label for="ch">I authorize Akbartravels.com to contact me and have read the Terms and Conditions.</label>
            </div>
            <div class="checkbox pb-2 mt-2 mb-2">
              <input type="checkbox" id="ch1">
              <label for="ch1">I agree to receive updates & offers from Akbartravels.com</label>
            </div>
            <div class="col-12 mt-3">
              <div class="row justify-content-between">
                <div class="col-6 row">
                  <h5>{{contactb2c}} <span>(10am - 8pm)</span></h5>
                </div>
                <div class="col-6">
                  <div class="row">
                    <button (click)="createLead()" class="btn btn-primary btn-block search_btn" type="button">Call
                      Me</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!------------login Signup modal end------------------------------>
<!-- Content end -->

<app-footer></app-footer>



<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <app-loading-modal></app-loading-modal>
    </div>
  </div>
</div>

<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter">
  Launch loading modal
</button>

<div id="waitingIcon" class="modal fade" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
          <button type="button" class="close" id="closeWaiting" data-dismiss="modal" aria-label="Close"> <span
                  aria-hidden="true">&times;</span>
          </button>
          <div class="card-header">
              <div class="col-12 col-sm-12 col-lg-12 text-center">
                  <div class="row align-items-center trip-title" style=" display: inline-flex;">
                      <div class="col col-sm-auto text-center text-sm-left">
                          <h6 class="m-0 trip-place text-center ">Searching Cruises <br />Cabin :
                              Interior
                              <br /> Pax : 2 Adults
                          </h6>
                      </div>
                  </div>
              </div>
              <div class="modal-body">
                  <img src="./assets/images/progress.gif" style="margin-left: 40%; height:90px; width:90px">
              </div>
          </div>
      </div>
  </div>
</div>